import { render, staticRenderFns } from "./CustomerReceivesList.vue?vue&type=template&id=6b9fa40a"
import script from "./CustomerReceivesList.vue?vue&type=script&lang=js"
export * from "./CustomerReceivesList.vue?vue&type=script&lang=js"
import style0 from "./CustomerReceivesList.vue?vue&type=style&index=0&id=6b9fa40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports